/** Used to match @see KeyboardEvent.code values. */
export enum KeyCode {
  arrowDown = 'ArrowDown',
  arrowLeft = 'ArrowLeft',
  arrowRight = 'ArrowRight',
  arrowUp = 'ArrowUp',
  enter = 'Enter',
  space = 'Space',

  digit0 = 'Digit0',
  digit9 = 'Digit9',
  numpad0 = 'Numpad0',
  numpad9 = 'Numpad9',

  d = 'KeyD',
  e = 'KeyE',
  y = 'KeyY'
}
